export const DEFAULT_HEADING = 'For Members';

const itemSchema = {
    title: 'Accordion item',
    fieldsets: [
        {
            id: 'default',
            title: 'Default',
            fields: ['title', 'description'],
        },
    ],
    properties: {
        title: {title: 'Title', type: 'string'},
        description: {title: 'Description', widget: 'textarea'},
    },
    required: ['title'],
};

const Schema = () => ({
    title: 'Members Block',
    fieldsets: [
        {id: 'default', title: 'Content', fields: ['heading', 'items']},
        {
            id: 'register',
            title: 'Register box',
            fields: [
                'register_heading',
                'register_text',
                'signup_label',
                'login_label',
                'show_register_box',
            ],
        },
    ],
    properties: {
        heading: {
            title: 'Heading',
            type: 'string',
            description: 'Heading above the accordion',
            default: DEFAULT_HEADING,
        },
        items: {
            title: 'Accordion items',
            widget: 'object_list',
            schema: itemSchema,
            description:
                'Add, edit, reorder, or remove accordion items. Starts empty by default.',
            default: [],
        },
        register_heading: {
            title: 'Register heading',
            type: 'string',
            default: 'Not yet registered?',
        },
        register_text: {
            title: 'Register text',
            widget: 'textarea',
            default: 'Create an account to access all member resources and events.',
        },
        signup_label: {title: 'Sign up button label', type: 'string', default: 'Sign up'},
        login_label: {title: 'Log in button label', type: 'string', default: 'Log in'},
        show_register_box: {title: 'Show register box', type: 'boolean', default: true},
    },
    required: [],
});

export default Schema;